export enum TipoEndividamentoEnum {
  BancosFundos = 1,
  FornecedoresTradings,
  AquisicaoPropriedadesRurais
}
